import { type GQLError } from '@egw/clients'
import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'
import { type BankAccountActivityInput, type BankAccountActivityOutput, type BankAccountDetail } from '../../models'
import { getBankAccountDetail, getBankActivity } from '../../services'

/**
 * Bank Account Details state hook
 * @param options - tanstack useQuery options
 * @returns tanstack useQuery result, data is of type BankAccountDetail
 */
export const useBankAccountDetail = (
  alias: number,
  options?: Omit<UseQueryOptions<BankAccountDetail, GQLError>, 'queryKey' | 'queryFn' | 'select'>,
): UseQueryResult<BankAccountDetail, GQLError> =>
  useQuery<BankAccountDetail, GQLError>({
    queryKey: ['bankAccountDetail', { alias }],
    queryFn: () => getBankAccountDetail(alias),
    ...options,
  })

/**
 * Bank Account Activity state hook
 * @param alias - bank account alias
 * @param options - tanstack useQuery options
 * @returns
 */
export const useBankActivity = (
  bankAccountActivityInput: BankAccountActivityInput,
  options?: Omit<UseQueryOptions<BankAccountActivityOutput, GQLError>, 'queryKey' | 'queryFn' | 'select'>,
): UseQueryResult<BankAccountActivityOutput, GQLError> => {
  return useQuery<BankAccountActivityOutput, GQLError>({
    queryKey: ['bankAccountActivity', { alias: bankAccountActivityInput.alias }],
    queryFn: () => getBankActivity(bankAccountActivityInput),
    ...options,
  })
}
